<template>
    <div class="weather">
        <div class="cityList">
            <span
                v-for="(addr,index) in addressList"
                :key="index"
                :class="{'active':index == addressIndex}"
                @click="changeCity(index)"
            >{{addr.name}}</span>
        </div>

        <mt-loadmore :top-method="loadTop" :bottom-all-loaded="true" class="info" ref="loadmore">
            <div class="updateTime">{{sendTime}}更新</div>
            <div class="temp">
                {{maxTemp}}/{{minTemp}}°
            </div>
            <div class="rain">
                <div>{{weather}}</div>
                <div>{{windDText}} {{windVText(windV)}}</div>
                <!-- <div>过去1小时降水0.1mm;</div>
                <div>过去2小时降水0.1mm;</div>
                <div>过去3小时降水0.1mm;</div> -->
            </div>
            <div class="voice" @click="onClickVoice">
                <i class="iconfont icon-yuyin"></i>
                <audio autoplay="autoplay" :key="textOfVoiceCount" v-if="textOfVoice">
                    <source
                        :src="`//tsn.baidu.com/text2audio?lan=zh&ctp=1&cuid=dfesdf&tok=${token}&tex=${textOfVoice}&per=0&spd=5&pit=5&aue=3`"
                        type="audio/mpeg"
                    />
                </audio>
            </div>
            <div class="hour24">
                <label>一周预报</label>
                <div>
                    <div class="data">
                        <div v-for="(item,index) in day7" :key="index">
                            <span>{{item.week}}</span>
                            <br />
                            <img :src="loadImg(item.weatherCode1)" alt />
                        </div>
                    </div>
                    <div class="charts" ref="charts24"></div>
                    <div class="data">
                        <div v-for="(item,index) in day7" :key="index">
                            <img :src="loadImg(item.weatherCode2)" alt />
                            <br />
                            <span>{{item.time}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="zhishu">
                <div v-for="(item,index) in zhishuList" :key="index" @click="zsClick(zhishu[item.key].info)">
                    <i class="iconfont" :class="item.icon"></i>
                    <div>{{zhishu[item.key]?zhishu[item.key].type : '无'}}</div>
                    <div>{{item.name}}</div>
                </div>
            </div>
        </mt-loadmore>
    </div>
</template>

<script>
import echarts from "echarts";
import axios from 'axios';
import { Toast } from 'mint-ui';

export default {
    data() {
        return {
            echart:null,
            code: '',
            name:'',
            addressIndex: 0,
            addressList: [ 
                // {name:"海淀",code:'123'},
            ],
            textOfVoiceCount: 0,
            textOfVoice: null,
            token: "24.8d85cf95f38397fe732f78bfdea1f39c.2592000.1591953102.282335-19866011", //百度语音合成token，需后台更新，有效期30天
            day7: [],
            sendTime:'',
            maxTemp:'',
            minTemp:'',
            weather:'',
            windD:0,
            windV:0,
            playVoice:false,
            zhishu:{},
            zhishuList:[
                {name:'穿衣指数',key:'zs_cy',icon:'icon-yifuhuanfu'},
                {name:'洗车指数',key:'zs_xc',icon:'icon-xichekaidan'},
                {name:'晾晒指数',key:'zs_ls',icon:'icon-fuzhuang-yijia'},
                {name:'紫外线指数',key:'zs_zwx',icon:'icon-rishai'},
                {name:'晨练指数',key:'zs_cl',icon:'icon-yundong'},
                {name:'旅游指数',key:'zs_ly',icon:'icon-lvyou'},
                {name:'空调指数',key:'zs_kt',icon:'icon-kongtiao'},
                {name:'化妆指数',key:'zs_hz',icon:'icon-huazhuangpin'},
                {name:'感冒指数',key:'zs_gm',icon:'icon-yaowan'},
            ],
        };
    },
    created() {
        this.code = this.$route.params.code;
        this.name = this.$route.params.name;
        this.addressList.push({code:this.code,name:this.name});
    },
    mounted() {
        this.echart = echarts.init(this.$refs.charts24);
        this.loadData();
        this.ajax('wxInterface/areaQuery',{code:this.code}, data => {
            this.addressList.push(...data);
        });
    },
    computed: {
        windDText(){
            return this.getBWWindDStr(this.windD);
        },
    },
    methods: {
        loadImg(weatherCode) {
            if(weatherCode > 31){
                weatherCode = 'acv';
            }
            return require(`../assets/weather/${weatherCode}.png`);
        },
        windVText(windV){
            return this.getWindVStr(windV);
        },
        //切换城市
        changeCity(index) {
            this.addressIndex = index;
            this.code = this.addressList[index].code;
            this.name = this.addressList[index].name;
            this.loadData();
        },
        //下拉刷新
        loadTop() {
            this.loadData(() => {
                this.$refs.loadmore.onTopLoaded();
            });
        },
        //播放语音
        onClickVoice() {
            let text = "无天气信息，请稍后再试。";
            if(this.playVoice){
                this.textOfVoiceCount++;
                const windV = this.windVText(this.windV).replace('~','到');
                let wind = '';
                if(windV !== '无风'){
                    wind = ',' + this.windDText + windV;
                }
                text = `${this.name}${this.weather}${wind},今天最高气温${this.maxTemp}度,最低气温${this.minTemp}`;
            }
            this.textOfVoice = text;
            // window.speechSynthesis.speak(new window.SpeechSynthesisUtterance(text))
        },
        //加载数据
        loadData(func) {
            this.playVoice = false;
            this.echart.clear();
            this.ajax('wxInterface/findAreaWeather',{code:this.code},data => {
                if(data == undefined){
                    return;
                }
                this.playVoice = true;
                this.sendTime = data.sendTime;
                this.maxTemp = Number.parseInt(data.maxTemp) || '-';
                this.minTemp = Number.parseInt(data.minTemp) || '-';
                this.weather = data.weather || '';
                this.humidity = data.humidity;
                this.windD = data.windD;
                this.windV = data.windV;
                this.day7 = data.day7;
                
                this.echart.setOption({
                    color: ['#ffffff','#68a838'],
                    xAxis: {
                        type: "category",
                        data: this.day7.map(item => item.time),
                        show: false
                    },
                    yAxis: {
                        type: "value",
                        show: false
                    },
                    grid: {
                        left: 0,
                        right: 0,
                        top: "23px",
                        bottom: "5px"
                    },
                    series: [
                        {
                            data: this.day7.map(item => item.maxTemp),
                            type: "line",
                            label: {
                                normal: {
                                    show: true,
                                    position: "top"
                                }
                            }
                        },
                        {
                            data: this.day7.map(item => item.minTemp),
                            type: "line",
                            label: {
                                normal: {
                                    show: true,
                                    position: "top"
                                }
                            }
                        }
                    ]
                });
                if(func != undefined){
                    func();
                }
            },()=>{
                if(func != undefined){
                    func();
                }
            });

            axios.get('https://api.help.bj.cn/apis/life29/?id=' + this.name).then(res => {
                if(res.status == 200 && res.data.status == '0'){
                    this.zhishu = res.data.data;
                }
            }).catch(e => console.log(e));
        },
        //指数点击事件
        zsClick(info){
            Toast({
                message: info,
            });
        }
    }
};
</script>

<style lang="less" scoped>
.weather {
    background-image: url(../assets/background/bg.jpg);
    background-position: top;
    background-size: 100% auto;
    background-repeat: no-repeat;
}
div {
    color: white;
}
.cityList {
    white-space: nowrap;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.2);
    font-size: 0;
    > span {
        display: inline-block;
        font-size: 1rem;
        padding: 8px;

        &.active {
            background-color: #4caf50;
        }
    }
}

.info {
    padding: 10px 0;
    box-sizing: border-box;
    position: relative;

    > div {
        > .updateTime {
            color: rgba(255, 255, 255, 0.8);
            text-align: center;
            font-size: 0.7rem;
        }

        > .temp {
            text-align: center;
            padding-top: 30px;
            font-size: 6rem;
        }

        > .rain {
            padding: 10px 20px;
            > div {
                font-size: 0.8rem;
                padding: 3px;
            }
        }
        > .voice {
            position: absolute;
            top: 65vw;
            left: 86vw;
            background-color: rgba(0, 0, 0, 0.3);
            border-radius: 50%;
            width: 40px;
            height: 40px;
            text-align: center;
            line-height: 40px;
        }
        > .hour24 {
            margin-top: 200px;
            background-color: #246090;
            > label {
                display: block;
                padding: 10px;
                border-bottom: 1px solid rgba(255, 255, 255, 0.3);
            }
            > div {
                overflow: auto;

                > .charts {
                    width:100%;
                    height: 100px;
                }

                > .data {
                    display: flex;
                    flex-flow: row nowrap;

                    > div {
                        flex: 1;
                        text-align: center;
                        padding-bottom: 10px;
                        > img {
                            width: 30px;
                            height: 30px;
                        }
                        > span {
                            font-size: small;
                        }
                    }
                }
            }
        }

        > .zhishu {
            margin-top: 30px;
            display: flex;
            flex-flow: row wrap;

            > div{
                flex: 0 0 33.3333%;
                text-align: center;
                box-sizing: border-box;
                border-right: 1px solid rgba(255, 255, 255, 0.3);
                border-top: 1px solid rgba(255, 255, 255, 0.3);
                padding:20px 0;

                &:nth-child(n+5){
                    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
                }
                &:nth-child(3n+3){
                    border-right: none;
                }

                >i{
                    font-size: 2.5rem;
                }
                >div{
                    font-size: 1.3rem;
                    font-weight: 300;
                    &:nth-of-type(1){
                        padding: 10px 0;
                    }
                    &:last-child{
                        font-weight: 200;
                        font-size: 1rem;
                    }
                }
            }
        }
    }
}
</style>